export default __webpack_public_path__ + "static/media/2007-IMcover.d8a71000.jpg";